module.exports = __webpack_public_path__ + "static/media/loader_light.75228a9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader_light.svg
// module id = 257
// module chunks = 1